// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-info {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  background: var(--color-parchment-100);
  background-image:
    radial-gradient(
      circle at 20% 30%,
      rgba(139, 69, 19, 0.10) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 70%,
      rgba(160, 82, 45, 0.06) 0%,
      transparent 50%
    ),
    repeating-linear-gradient(
      0deg,
      transparent,
      transparent 2px,
      rgba(139, 69, 19, 0.04) 2px,
      rgba(139, 69, 19, 0.04) 3px
    );
  border: 3px solid var(--color-wood-700);
  border-radius: var(--radius-xl);
  padding: var(--space-5);
  box-shadow: var(--shadow-card);
}

/* Image — preserve aspect ratio, no cropping */
.game-info__cover-wrap {
  width: 100%;
  border-radius: var(--radius-lg);
  overflow: hidden;
  background: linear-gradient(135deg, var(--color-wood-800), var(--color-wood-700));
}

.game-info__cover {
  width: 100%;
  height: auto;
  display: block;
}

.game-info__cover-placeholder {
  width: 100%;
  aspect-ratio: 16 / 9;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 72px;
  background: linear-gradient(135deg, var(--color-wood-800), var(--color-wood-700));
}

/* Title */
.game-info__title {
  font-family: var(--font-heading);
  font-size: var(--font-size-h2);
  font-weight: var(--font-weight-bold);
  color: var(--color-fire-600);
  line-height: var(--line-height-h2);
  margin: 0;
}

/* Meta row */
.game-info__meta {
  display: flex;
  gap: var(--space-3);
  flex-wrap: wrap;
  padding-bottom: var(--space-3);
  border-bottom: 2px solid var(--color-wood-600);
}

.game-info__meta-item {
  font-family: var(--font-body);
  font-size: var(--font-size-body);
  color: var(--color-wood-600);
  font-weight: var(--font-weight-semibold);
  white-space: nowrap;
}

/* Tags */
.game-info__tags {
  /* no extra margin needed, gap from parent handles spacing */
}

/* Description */
.game-info__description {
  font-family: var(--font-body);
  font-size: var(--font-size-body);
  color: var(--color-text-primary);
  line-height: var(--line-height-relaxed);
  margin: 0;
  white-space: pre-wrap;
}

/* External link */
.game-info__link {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  font-family: var(--font-body);
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-semibold);
  color: var(--color-fire-500);
  text-decoration: none;
  transition: color var(--transition-fast);
}

.game-info__link:hover {
  color: var(--color-fire-700);
  text-decoration: underline;
}

@media (max-width: 425px) {
  .game-info {
    padding: var(--space-3);
    gap: var(--space-3);
    border-width: 2px;
    border-radius: 14px;
  }

  .game-info__title {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
  }

  .game-info__cover-placeholder {
    font-size: 56px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/games/GameInfo.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC;EACtC;;;;;;;;;;;;;;;;;KAiBG;EACH,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,+BAA+B;EAC/B,gBAAgB;EAChB,iFAAiF;AACnF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iFAAiF;AACnF;;AAEA,UAAU;AACV;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,oCAAoC;EACpC,4BAA4B;EAC5B,kCAAkC;EAClC,SAAS;AACX;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,4BAA4B;EAC5B,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,4DAA4D;AAC9D;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,gCAAgC;EAChC,uCAAuC;EACvC,SAAS;EACT,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;EAChC,wCAAwC;EACxC,4BAA4B;EAC5B,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE;IACE,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,kCAAkC;EACpC;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".game-info {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-4);\n  background: var(--color-parchment-100);\n  background-image:\n    radial-gradient(\n      circle at 20% 30%,\n      rgba(139, 69, 19, 0.10) 0%,\n      transparent 50%\n    ),\n    radial-gradient(\n      circle at 80% 70%,\n      rgba(160, 82, 45, 0.06) 0%,\n      transparent 50%\n    ),\n    repeating-linear-gradient(\n      0deg,\n      transparent,\n      transparent 2px,\n      rgba(139, 69, 19, 0.04) 2px,\n      rgba(139, 69, 19, 0.04) 3px\n    );\n  border: 3px solid var(--color-wood-700);\n  border-radius: var(--radius-xl);\n  padding: var(--space-5);\n  box-shadow: var(--shadow-card);\n}\n\n/* Image — preserve aspect ratio, no cropping */\n.game-info__cover-wrap {\n  width: 100%;\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  background: linear-gradient(135deg, var(--color-wood-800), var(--color-wood-700));\n}\n\n.game-info__cover {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.game-info__cover-placeholder {\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 72px;\n  background: linear-gradient(135deg, var(--color-wood-800), var(--color-wood-700));\n}\n\n/* Title */\n.game-info__title {\n  font-family: var(--font-heading);\n  font-size: var(--font-size-h2);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-fire-600);\n  line-height: var(--line-height-h2);\n  margin: 0;\n}\n\n/* Meta row */\n.game-info__meta {\n  display: flex;\n  gap: var(--space-3);\n  flex-wrap: wrap;\n  padding-bottom: var(--space-3);\n  border-bottom: 2px solid var(--color-wood-600);\n}\n\n.game-info__meta-item {\n  font-family: var(--font-body);\n  font-size: var(--font-size-body);\n  color: var(--color-wood-600);\n  font-weight: var(--font-weight-semibold);\n  white-space: nowrap;\n}\n\n/* Tags */\n.game-info__tags {\n  /* no extra margin needed, gap from parent handles spacing */\n}\n\n/* Description */\n.game-info__description {\n  font-family: var(--font-body);\n  font-size: var(--font-size-body);\n  color: var(--color-text-primary);\n  line-height: var(--line-height-relaxed);\n  margin: 0;\n  white-space: pre-wrap;\n}\n\n/* External link */\n.game-info__link {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-1);\n  font-family: var(--font-body);\n  font-size: var(--font-size-body);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-fire-500);\n  text-decoration: none;\n  transition: color var(--transition-fast);\n}\n\n.game-info__link:hover {\n  color: var(--color-fire-700);\n  text-decoration: underline;\n}\n\n@media (max-width: 425px) {\n  .game-info {\n    padding: var(--space-3);\n    gap: var(--space-3);\n    border-width: 2px;\n    border-radius: 14px;\n  }\n\n  .game-info__title {\n    font-size: var(--font-size-h3);\n    line-height: var(--line-height-h3);\n  }\n\n  .game-info__cover-placeholder {\n    font-size: 56px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
